import { userConfig1 } from "@/utils/request";
export const captcha = {
         data() {
           return {
             checkNeed: 0,
             showCheck: false
           };
         },
         computed: {
           captchaParams() {
             if (this.$refs.vcaptcha1) {
               return this.$refs.vcaptcha1.captchaParams;
             }
             if (this.$refs.vcaptcha2) {
               return this.$refs.vcaptcha2.captchaParams;
             }
           }
         },
         mounted() {
           this.initData();
         },
         methods: {
           initData() {
             userConfig1().then(({ body }) => {
               this.checkNeed = body.code == 0 ? body.data : 0;
             });
           },
           handleCheck(cb) {
             if (this.checkNeed) {
               this.loading = false;
               this.showCheck = true;
               return;
             }
             cb();
           },
           handleOpen(code, cb) {
             if (code == 18) {
               this.showCheck = true;
             } else {
              this.showCheck = false;
             }
             this.handleReset();
             cb && cb();
           },
           handleReset() {
             try {
               this.$refs.vcaptcha2.handleReset();
             } catch (error) {
               console.log(
                 "🚀 ~ file: captcha.js:37 ~ handleReset ~ error:",
                 error
               );
             }
             try {
               this.$refs.vcaptcha1.handleReset();
             } catch (error) {
               console.log(
                 "🚀 ~ file: captcha.js:45 ~ handleReset ~ error:",
                 error
               );
             }
           }
         }
       };



// WEBPACK FOOTER //
// ./src/mixins/captcha.js